import { render } from "./CreateTender.vue?vue&type=template&id=195be5b6"
import script from "./CreateTender.vue?vue&type=script&lang=js"
export * from "./CreateTender.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Tenders/CreateTender.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "195be5b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('195be5b6', __exports__)) {
    api.reload('195be5b6', __exports__)
  }
  
  module.hot.accept("./CreateTender.vue?vue&type=template&id=195be5b6", () => {
    api.rerender('195be5b6', render)
  })

}


export default __exports__